import React, { Component } from 'react';
import { ImageBackground, View, Text, StyleSheet, Pressable } from 'react-native';
import { bindActionCreators } from 'redux';
import { Routes, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { OPComponent, I18n, Navigation, ActivityOverlay } from './screens/components';
import { getUnauthRoutes } from './screens/routes';
import { COLOR, FONT, FONT_SIZE, THEME } from './constants/styles';

import LanguageSelect from './screens/auth/language_select';
import PrivacyButton from './screens/auth/privacy_button';

import { resetState } from './screens/auth/actions';
import { setLocalLanguagePreference } from './actions/actions';

import { AuthContainer } from './screens/auth/auth_views';

// Get the routes to populate into our Router
const unauthedRoutes = getUnauthRoutes();

const styles = StyleSheet.create({
  ...THEME,
  paneWrapper: {
    flex: 1,
    justifyContent: 'center',
    maxWidth: 400,
    width: '100%',
    marginHorizontal: 'auto',
  },
  tabWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    paddingHorizontal: 30,
  },
  tab: {
    flex: 0.5,
    borderBottomColor: COLOR.textDisabled,
    borderBottomWidth: 2,
    paddingBottom: 10,
    alignContent: 'center',
    alignItems: 'center',
  },
});

class UnauthedAppContainer extends OPComponent {
  constructor(props) {
    super(props);
  }

  handleSetLocale = (locale) => {
    this.props.actions.setLocalLanguagePreference(locale);
  };

  changeTab = (screen) => {
    Navigation.openScreen({ screen }, null, false);
  };

  renderRoute = (name) => {
    const Comp = unauthedRoutes[name];
    return <Route key={name} exact path={`/${name}`} element={<Comp />} />;
  };

  render() {
    let { activeTab, needsMFASetup, needsMFACode } = this.props;
    const showingMfa = needsMFASetup || needsMFACode;
    const hideTabs =
      showingMfa ||
      (activeTab !== 'Login' && activeTab !== 'Register' && activeTab !== 'ForgotPassword');

    return (
      <AuthContainer>
        <View style={{ flexDirection: 'row', minHeight: '100%' }}>
          <Pressable
            style={{ flex: 1, minHeight: '100%' }}
            onPress={() => {
              this.changeTab('Home');
            }}
          >
            <View style={{ flex: 1, minHeight: '100%' }}>
              <ImageBackground
                style={{ width: '100%', height: '100%' }}
                source={require('../resources/auth_bg/web-bg-login.jpg')}
              />
            </View>
          </Pressable>
          <View style={{ flex: 1 }}>
            <View style={styles.paneWrapper}>
              <View style={[styles.tabWrapper, hideTabs ? { display: 'none' } : null]}>
                <Pressable
                  style={[
                    styles.tab,
                    activeTab === 'Login' ? { borderBottomColor: COLOR.emphasis } : null,
                  ]}
                  onPress={() => {
                    this.changeTab('Login');
                  }}
                >
                  <Text style={styles.labelText}>{I18n.ac('auth.login')}</Text>
                </Pressable>
                <Pressable
                  style={[
                    styles.tab,
                    activeTab === 'Register' ? { borderBottomColor: COLOR.emphasis } : null,
                  ]}
                  onPress={() => {
                    this.changeTab('Register');
                  }}
                >
                  <Text style={styles.labelText}>{I18n.ac('auth.signUp')}</Text>
                </Pressable>
              </View>
              <View>
                <Routes>
                  <Route path="/" exact element={<unauthedRoutes.Login />} />
                  <Route path="/Login" exact element={<unauthedRoutes.Login />} />
                  {Object.keys(unauthedRoutes).map(this.renderRoute)}
                  <Route path="*" exact element={<unauthedRoutes.Login />} />
                </Routes>
              </View>

              {!showingMfa && (
                <View>
                  <LanguageSelect
                    locales={this.props.locales}
                    selectedLocale={this.props.selectedLocale || 'en-US'}
                    onSetLocale={this.handleSetLocale}
                  />
                  <PrivacyButton componentId={this.props.componentId} />
                </View>
              )}
            </View>
            {this.props.authStatus === 'requesting' && (
              <ActivityOverlay
                overrideStyles={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  paddingTop: '50%',
                }}
              />
            )}
          </View>
        </View>
      </AuthContainer>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let activeTab = ownProps.pathName?.substring(1) || 'Login';
  activeTab = activeTab === 'Home' ? 'Login' : activeTab;

  return {
    activeTab,
    authStatus: state.screens.auth.status,
    selectedLocale: state.application.locale,
    locales: state.entities.metaData.locales,
    needsMFASetup: state.screens.auth.needsMFASetup,
    needsMFACode: state.screens.auth.needsMFACode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ resetState, setLocalLanguagePreference }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnauthedAppContainer);
